import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const StyledContentWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  padding: 20,
});

export const StyledTitleSection = styled("div")(({ theme }) => ({
  marginBottom: 8,
  textAlign: "center",

  "& h5": {
    fontSize: 32,
    fontFamily: theme.fonts.regular,
    lineHeight: "44px",
    fontWeight: "normal",
    margin: 0,
  },
}));

export const StyledScrollableContent = styled("div")(({ theme }) => ({
  maxHeight: 300,
  overflowY: "auto",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 4,
  padding: 16,
  fontSize: 14,
  lineHeight: 1.6,
  flex: 1,

  '&[data-error="true"]': {
    color: theme.palette.error.main,
  },

  "& a": {
    color: theme.colors.sapphire,
    textDecoration: "none",
    fontWeight: 600,
    "&:hover": {
      color: theme.colors.navy,
    },
  },

  "& p": {
    marginTop: 10,
    marginBottom: 0,
    lineHeight: 1.43,
    fontSize: 14,
    fontFamily: "AvenirNextLTCom-Regular, Arial, sans-serif",
  },
}));

export const StyledCheckboxWrapper = styled("div")({
  display: "flex",
  position: "relative",
  alignItems: "flex-start",
});

export const StyledDisabledOverlay = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  width: 42,
  height: 42,
  cursor: "pointer",
  zIndex: 1,
});

export const StyledErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  marginLeft: 50,
}));

export const StyledHelperText = styled(Typography)(({ theme }) => ({
  color: theme.colors.shades[700],
  fontSize: 16,
  padding: "30px 0",
  paddingBottom: 40,
  textAlign: "center",
}));
